import { useCallback } from 'react';
import useSetPdpEditOrderErrorMessage from './useSetPdpEditOrderErrorMessage';

const useResetPdpEditOrderErrorMessage = () => {
  const setPdpEditOrderErrorMessage = useSetPdpEditOrderErrorMessage();

  const resetPdpEditOrderErrorMessage = useCallback(() => {
    setPdpEditOrderErrorMessage(null);
  }, [setPdpEditOrderErrorMessage]);

  return resetPdpEditOrderErrorMessage;
};

export default useResetPdpEditOrderErrorMessage;
